import { GetNewEntrySignificance } from '../../GetNewEntrySignificance';
import { IValidationResult, validResult } from '../ValidateEntry';

export const ValidateMissingData = (
	inputValues: string[]
): IValidationResult => {
	// let invalidInputName: string = '';

	// const propertiesToValidate = [
	// 	ELogEntry.entry,
	// 	ELogEntry.kips,
	// 	ELogEntry.mood,
	// 	ELogEntry.timestamp,
	// 	ELogEntry.energy
	// ];

	// propertiesToValidate.forEach((property) => {
	// 	if (!inputValues[property]) {
	// 		invalidInputName = ELogEntry[property];
	// 	}
	// });

	// const inputIsInvalid = invalidInputName !== '';
	// if (inputIsInvalid) {
	// 	return {
	// 		isValid: false,
	// 		errorMessage: `Please complete the Log Entry form before submitting: ${invalidInputName}. Provided inputValues: ${JSON.stringify(
	// 			inputValues
	// 		)}`
	// 	};
	// }

	if (!GetNewEntrySignificance(inputValues[0])) {
		return {
			isValid: false,
			errorMessage: 'Cannot find entry significance'
		};
	}

	return validResult;
};
